export const EXPENSE_TYPES = {
  ALL: 'ALL',
  EXPENSE: 'EXPENSE',
  MILEAGE: 'MILEAGE',
  DIET: 'DIET'

}
